import { Model } from '@vuex-orm/core';
import Zaui from '@/include/api';
import { mergeAllLocaleMessages } from '@/i18n';

// TODO try to inherit fields method?
export default class P2P extends Model {
  static entity = 'p2ps';

  get originOptions() {
    return P2P.mapToOptions(this.origins);
  }

  get destinationOptions() {
    return P2P.mapToOptions(this.destinations);
  }

  get originLocationsOptions() {
    return P2P.mapToOptions(this.originLocations);
  }

  get destinationLocationsOptions() {
    return P2P.mapToOptions(this.destinationLocations);
  }


  static fields() {
    return {
      id: this.number(),
      type: this.string(),
      category: this.number(),
      description: this.string(),
      image: this.string(),
      name: this.string(),

      lang: this.attr(),

      price: this.attr(),
      listPrice: this.attr(),

      activityType: this.attr(),
      moreInfo: this.string(),
      policies: this.string(),
      pax: this.attr(),

      origins: this.attr([]),
      destinations: this.attr([]),

      originLocations: this.attr([]),
      destinationLocations: this.attr([]),

      transportationRoutes: this.attr([]),
      transportationRoutesReturn: this.attr([]),

      shouldHaveTransportationRoutes: this.boolean(),

      relatedProducts: this.attr([]),
    };
  }

  static fetch(id, state) {
    return Zaui.p2p.get(id, state).then(data => {
      P2P.insert({ data });
    });
  }

  static fetchAirlines() {
    return Zaui.p2p.airlines();
  }

  static beforeCreate(model) {
    if (model.lang) {
      mergeAllLocaleMessages(model.lang);
    }
  }

  static mapToOptions(arr, includeEmpty=true, valueKey='id', labelKey='name', emptyLabel='') {
    let options = arr.map(item => {
      return { value: item[valueKey], label: item[labelKey] };
    });

    // we provide an empty default value.
    if (includeEmpty && options.length) {
      options.unshift({ value: undefined, label: emptyLabel });
    }
    return options;
  }
}